import React from 'react';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>{t('privacy.title')}</h1>
        <p className="last-updated">{t('privacy.lastUpdated')}: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>{t('privacy.intro.title')}</h2>
          <p>{t('privacy.intro.text')}</p>
        </section>

        <section>
          <h2>{t('privacy.dataCollection.title')}</h2>
          <p>{t('privacy.dataCollection.text')}</p>
          <ul>
            <li>{t('privacy.dataCollection.item1')}</li>
            <li>{t('privacy.dataCollection.item2')}</li>
            <li>{t('privacy.dataCollection.item3')}</li>
            <li>{t('privacy.dataCollection.item4')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('privacy.cookies.title')}</h2>
          <p>{t('privacy.cookies.text')}</p>
          <p>{t('privacy.cookies.text2')}</p>
        </section>

        <section>
          <h2>{t('privacy.dataUsage.title')}</h2>
          <p>{t('privacy.dataUsage.text')}</p>
          <ul>
            <li>{t('privacy.dataUsage.item1')}</li>
            <li>{t('privacy.dataUsage.item2')}</li>
            <li>{t('privacy.dataUsage.item3')}</li>
            <li>{t('privacy.dataUsage.item4')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('privacy.dataSharing.title')}</h2>
          <p>{t('privacy.dataSharing.text')}</p>
          <p>{t('privacy.dataSharing.text2')}</p>
        </section>

        <section>
          <h2>{t('privacy.userRights.title')}</h2>
          <p>{t('privacy.userRights.text')}</p>
          <ul>
            <li>{t('privacy.userRights.item1')}</li>
            <li>{t('privacy.userRights.item2')}</li>
            <li>{t('privacy.userRights.item3')}</li>
            <li>{t('privacy.userRights.item4')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('privacy.security.title')}</h2>
          <p>{t('privacy.security.text')}</p>
        </section>

        <section>
          <h2>{t('privacy.children.title')}</h2>
          <p>{t('privacy.children.text')}</p>
        </section>

        <section>
          <h2>{t('privacy.changes.title')}</h2>
          <p>{t('privacy.changes.text')}</p>
        </section>

        <section>
          <h2>{t('privacy.contact.title')}</h2>
          <p>{t('privacy.contact.text')}</p>
          <p>
            <strong>{t('privacy.contact.email')}</strong>: contact@dailyzodiac.ai<br />
            <strong>{t('privacy.contact.website')}</strong>: <a href="https://dailyzodiac.ai">dailyzodiac.ai</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
